import { Fragment } from 'react';
import styled from 'styled-components';

const TaskTextFields = ({ task, showAll }) => (
  <>
    <TextFieldsWrapper>
      {task.orderId && (
        <>
          <FieldLabel>Työnumero</FieldLabel>
          <Field>{task.orderId}</Field>
        </>
      )}

      {/* Hide non-summary fields if accordion is not open */}
      {task.presentables.map(presentable =>
        presentable.summary || showAll ? (
          <Fragment key={presentable.name}>
            <FieldLabel>{presentable.label}</FieldLabel>
            <Field>{presentable.value}</Field>
          </Fragment>
        ) : null
      )}

      <FieldLabel>Tilaajan nimi</FieldLabel>
      <Field>{task.initiator.name}</Field>

      {!!showAll && (
        <>
          <FieldLabel>Palveluntuottajan puhelin</FieldLabel>
          <Field>{task.provider.telephone || '-'}</Field>
        </>
      )}

      {!!showAll && task.providerPhone && (
        <>
          <FieldLabel>
            {task.providerPhoneDescription || 'Tekijän puhelin'}
          </FieldLabel>
          <Field>{task.providerPhone || '-'}</Field>
        </>
      )}

      {!!task.cancelReason && (
        <>
          <FieldLabel>Perumissyy</FieldLabel>
          <Field>{task.cancelReason}</Field>
        </>
      )}
    </TextFieldsWrapper>
  </>
);

const TextFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 10px;
  row-gap: 3px;

  background: white;
  width: 100%;

  line-height: 22px;
  // text-wrap: nowrap;

  @media (max-width: 575px) {
    text-wrap: balance;
  }
`;

const FieldLabel = styled.div`
  display: inline-block;
  text-align: left;
  width: fit-content;
  color: var(--primaryColor);
`;

const Field = styled.div`
  display: inline-block;
  text-align: left;
  width: fit-content;
  margin-left: 10px;
  text-wrap: balance;
  word-break: normal;
  hyphens: auto;
`;

export default TaskTextFields;
